import { render, staticRenderFns } from "./CollaboratorItem.vue?vue&type=template&id=75cd9b4c&scoped=true&"
import script from "./CollaboratorItem.vue?vue&type=script&lang=js&"
export * from "./CollaboratorItem.vue?vue&type=script&lang=js&"
import style0 from "./CollaboratorItem.vue?vue&type=style&index=0&id=75cd9b4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75cd9b4c",
  null
  
)

export default component.exports